module.exports = __webpack_public_path__ + "static/howard-katzenberg-400w-103018-98b02b240eb715f9ce2622eb4421161b.jpg";